import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CustomerContext } from '../CustomerContext';
import { Error } from '@app/shared';

export default function CustomerSearch() {
  const navigate = useNavigate();
  const { error, setError, customerInformationService } = useContext(CustomerContext);
  const [searchResults, setSearchResults] = useState(undefined as any);
  const [customerId, setCustomerId] = useState(undefined as string);
  const [searching, setSearching] = useState(false as any);
  const [givenName, setGivenName] = useState(undefined as string);
  const [familyName, setFamilyName] = useState(undefined as string);
  const [postalCode, setPostalCode] = useState(undefined as string);

  const onSearchSubmit = async (e) => {
    try {
      e.preventDefault();
      setSearchResults(undefined);

      if (givenName || familyName || postalCode) {
        setSearching(true);
        const searchResults = await customerInformationService.search(givenName, familyName, postalCode);
        setSearchResults(searchResults);
        setSearching(false);
      }
    } catch (error) {
      setSearching(false);
      setError({ source: 'Customer Search', ...error });
    }
  };

  const onGetCustomerById = async () => {
    try {
      setSearchResults(undefined);

      if (customerId) {
        setSearching(true);
        const searchResults = await customerInformationService.getCustomerById(customerId);
        setSearchResults([searchResults]);
        setSearching(false);
      }
    } catch (error) {
      setSearching(false);
      setError({ source: 'Get Customer By Id', ...error });
    }
  };

  return (
    <>
      <div>
        <Error error={error} setError={setError} />
        <div className="ui placeholder segment">
          <div className="ui two column very relaxed stackable grid">
            <div className="column">
              <div className="ui form">
                <div className="field">
                  <h3>Customer Id Search</h3>
                </div>
                <div className="field">
                  <div className="ui input">
                    <input
                      type="text"
                      placeholder="Customer Id"
                      onChange={(e) => setCustomerId(e.target.value)}
                      value={customerId || ''}
                    />
                    <button className="ui right attached blue submit button" onClick={onGetCustomerById}>
                      Search
                    </button>
                  </div>
                </div>
              </div>

              <div className="ui divider" />

              <form className="ui form" onSubmit={(e) => onSearchSubmit(e)}>
                <div className="field">
                  <h3>Customer Search</h3>
                </div>
                <div className="field">
                  <div className="ui labeled input">
                    <div className="ui label">Given Name</div>
                    <input
                      name="givenName"
                      type="text"
                      placeholder="Given Name"
                      value={givenName || ''}
                      onChange={(e) => setGivenName(e.target.value)}
                    />
                  </div>
                </div>

                <div className="field">
                  <div className="ui labeled input">
                    <div className="ui label">Family Name</div>
                    <input
                      name="familyName"
                      type="text"
                      placeholder="Family Name"
                      value={familyName || ''}
                      onChange={(e) => setFamilyName(e.target.value)}
                    />
                  </div>
                </div>

                <div className="field">
                  <div className="ui labeled input">
                    <div className="ui label">Postal Code</div>
                    <input
                      name="postalCode"
                      type="text"
                      placeholder="Postal Code"
                      value={postalCode || ''}
                      onChange={(e) => setPostalCode(e.target.value)}
                    />
                  </div>
                </div>

                <div className="field">
                  <div className="field">
                    <button className={`ui button blue submit ${searching && 'loading'}`} type="submit">
                      Search
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div className="middle aligned column">
              <button className="ui big button" onClick={() => navigate(`/customers/create`)}>
                Create customer
              </button>
            </div>
          </div>
          <div className="ui vertical divider">Or</div>
        </div>
      </div>
      {searchResults && (
        <>
          <h2>Search Results</h2>
          <table className="ui compact table">
            <thead>
              <tr>
                <th>Customer Id</th>
                <th>Account Number</th>
                <th>Given Name</th>
                <th>Middle Name</th>
                <th>Family Name</th>
                <th>Postal Code</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {searchResults.map((a: CustomerSearchResult) => (
                <tr key={a.customerId || a.id}>
                  <td>{a.customerId || a.id}</td>
                  <td>{a.accounts?.length > 0 ? a.accounts[0].accountNumber : 'no account'}</td>
                  <td>{a.givenName}</td>
                  <td>{a.middleName}</td>
                  <td>{a.familyName}</td>
                  <td>{a.address ? a.address.postalCode : 'no address'}</td>
                  <td>
                    <Link to={`/customers/${a.customerId || a.id}`} className="ui green button">
                      View Customer
                    </Link>
                    {a.accounts?.length > 0 && (
                      <Link to={`/accounts/${a.accounts[0].accountId}/summary`} className="ui green button">
                        View Account
                      </Link>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </>
  );
}
